import { frontendURL } from '../../../helper/URLHelper';
const AgenteIAView = () => import('./AgenteIAProductionView.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/agente-ia'),
      name: 'agente_ia_view',
      component: AgenteIAView,
      meta: { permissions: ['administrator', 'module_agente_ia'] },
    },
  ],
};
